import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ResetPasswordService } from "services/reset-password.service";

export enum ConfirmDialogEnum {
  DIALOG_MODAL = 1,
  SWITCH_ALERT = 2,
}

@Component({
  selector: "app-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.scss"],
})
export class ConfirmDialogComponent implements OnInit {
  @ViewChild("btnConfirm") private btnConfirm: ElementRef;
  @ViewChild("SweetAlertHTML") sweetAlertRef: any;
  @Input() type: ConfirmDialogEnum = ConfirmDialogEnum.DIALOG_MODAL;
  @Input() title: string = "Confirmação";
  @Input() focusConfirm = false;
  @Input() neutralStyle = false;
  @Input() confirmButtonClass?: string;
  @Input() cancelButtonClass?: string;
  @Input() message: string;
  @Input() messageConfirm: string = null;
  @Input() messageCancel: string = null;
  @Input() icon: string | undefined;

  constructor(
    public activeModal: NgbActiveModal,
    public resetPasswordService: ResetPasswordService
  ) { }

  ngOnInit(): void { }

  ngAfterViewChecked() {
    if (this.focusConfirm) this.btnConfirm?.nativeElement.focus();
  }

  ngAfterViewInit(): void {
    if (this.type === ConfirmDialogEnum.SWITCH_ALERT) {
      setTimeout(() => this.openSweetAlert());
    }
  }

  onConfirm(): void {
    this.activeModal.close(true);
  }

  onDismiss(): void {
    this.activeModal.close(false);
  }

  private openSweetAlert(): void {
    this.sweetAlertRef.fire().then((result) => {
      result.isConfirmed ? this.onConfirm() : this.onDismiss();
    });
  }
}
